import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess a quantum computing equation in 6 tries. After each guess, the
        color of the tiles will change to show how close your guess was to the
        equation.
      </p>
      <p className="mt-6 text-sm text-gray-500 dark:text-gray-300">
        Guesses comprise of{' '}
        <a
          href="https://en.wikipedia.org/wiki/Quantum_logic_gate"
          className="underline font"
        >
          quantum gates
        </a>{' '}
        operating on one{' '}
        <a
          href="https://en.wikipedia.org/wiki/Qubit"
          className="underline font"
        >
          qubit
        </a>
        's state. All valid equations must have a ket on each side.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="H" />
        <Cell value="H" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="X"
          status="correct"
        />
        <Cell value="|" />
        <Cell value="0" />
        <Cell value="⟩" />
        <Cell value="=" />
        <Cell value="|" />
        <Cell value="1" />
        <Cell value="⟩" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The gate X is in the equation and in the correct spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="H" />
        <Cell value="|" />
        <Cell value="0" />
        <Cell value="⟩" />
        <Cell value="=" />
        <Cell value="X" />
        <Cell value="X" />
        <Cell value="|" />
        <Cell
          value="+"
          isRevealing={true}
          isCompleted={true}
          status="present"
        />
        <Cell value="⟩" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The state + is in the equation but in the wrong spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="I" />
        <Cell value="S" isRevealing={true} isCompleted={true} status="absent" />
        <Cell value="|" />
        <Cell value="0" />
        <Cell value="⟩" />
        <Cell value="=" />
        <Cell value="I" />
        <Cell value="|" />
        <Cell value="0" />
        <Cell value="⟩" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The gate S is not in the equation in any spot.
      </p>

      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
        For any comments, reach me on{' '}
        <a href="https://twitter.com/QuantumYakar" className="underline font">
          twitter
        </a>
        .
      </p>
    </BaseModal>
  )
}
